
import React from 'react';
import { AlertCircle, CreditCard } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { formatPaymentMethod } from '@/utils/formatters';
import { PaymentMethodType } from '@/types';

interface EligibilityAlertProps {
  isEligible: boolean;
  balance: number;
  threshold: number;
  paymentMethodType?: PaymentMethodType;
}

const EligibilityAlert: React.FC<EligibilityAlertProps> = ({ 
  isEligible, 
  balance, 
  threshold,
  paymentMethodType 
}) => {
  const methodLabel = paymentMethodType ? formatPaymentMethod(paymentMethodType) : 'payment';
  
  if (!isEligible) {
    return (
      <Alert className="mb-6" variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Insufficient Balance</AlertTitle>
        <AlertDescription>
          Your current balance (${balance.toFixed(2)}) is below the minimum threshold 
          of ${threshold.toFixed(2)} required for {methodLabel}.
        </AlertDescription>
      </Alert>
    );
  }
  
  return (
    <Alert className="mb-6">
      <CreditCard className="h-4 w-4" />
      <AlertTitle>Payment Information</AlertTitle>
      <AlertDescription>
        <p>Your current balance is <strong>${balance.toFixed(2)}</strong></p>
        <p>Minimum payment threshold: <strong>${threshold.toFixed(2)}</strong></p>
        <p className="text-sm text-gray-500 mt-1">
          Payments are typically processed within 5-7 business days.
        </p>
      </AlertDescription>
    </Alert>
  );
};

export default EligibilityAlert;
